// localStorage is origin-scoped, so the admin app (port 3000) cannot seed the
// host app (port 3001) directly. The admin instead encodes the impersonation
// payload into the URL hash; we decode it here before React mounts and write
// it to the host origin's localStorage so the auth store rehydrates as
// authenticated.

const HASH_PARAM = 'impersonate'
const AUTH_STORAGE_KEY = 'basiyo-host-auth'
const IMPERSONATION_KEY = 'basiyo-pms-impersonation'

interface ImpersonationPayload {
  accessToken: string
  refreshToken: string
  user: {
    id: number
    email: string
    first_name: string
    last_name: string
    host_id: number
    host_name: string
  }
  hostId: number
  hostName: string
}

export function consumeImpersonationHash() {
  if (typeof window === 'undefined') return
  const raw = window.location.hash
  if (!raw.startsWith('#')) return

  const params = new URLSearchParams(raw.slice(1))
  const encoded = params.get(HASH_PARAM)
  if (!encoded) return

  try {
    const payload = JSON.parse(atob(encoded)) as ImpersonationPayload

    const authState = {
      state: {
        user: {
          id: payload.user.id,
          email: payload.user.email,
          first_name: payload.user.first_name,
          last_name: payload.user.last_name,
          scope: 'pms',
          is_active: true,
          host_id: payload.user.host_id,
          host_name: payload.user.host_name,
        },
        accessToken: payload.accessToken,
        refreshToken: payload.refreshToken,
        isAuthenticated: true,
      },
      version: 0,
    }
    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(authState))
    localStorage.setItem(
      IMPERSONATION_KEY,
      JSON.stringify({
        isActive: true,
        hostName: payload.hostName,
        hostId: payload.hostId,
      }),
    )
  } catch {
    // Malformed payload: leave localStorage untouched; the user lands on /login.
  }

  // Strip the impersonation token from the URL so it isn't kept in history or
  // copied if the user shares the link.
  params.delete(HASH_PARAM)
  const remainingHash = params.toString()
  const cleanUrl =
    window.location.pathname + window.location.search + (remainingHash ? '#' + remainingHash : '')
  window.history.replaceState(null, '', cleanUrl)
}
